import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faChevronDown } from '@fortawesome/pro-light-svg-icons';

export type ProLightChevronDownProps = IconComponentProps;

export const ProLightChevronDown = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightChevronDownProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faChevronDown}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faChevronDown}
    />
  );
};

ProLightChevronDown.displayName = 'ProLightChevronDown';
